// NPM Imports
import React, { Component } from "react";
// import ReactHtmlParser from "react-html-parser";
// import { ContentState } from "draft-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Label, Input } from "@revvsales/components";

// Components Imports
import CustomRevvEditor from "../../CustomRevvEditor";

// Internal Imports
import { TEMPLATE } from "../../../constants";

// Destructuring
const { CLAUSES_OPTIONS } = TEMPLATE;
// const { BLANK_HTML } = DRAFT;

class OptionView extends Component {
  static mode = "PREVIEW";

  _getOptionView = () => {
    const {
      // isActive,
      option: {
        // html,
        data,
      },
    } = this.props;
    // if (!isActive) {
    //   const defaultOption =
    //     data instanceof ContentState && data.getPlainText() === ""
    //       ? BLANK_HTML
    //       : html;
    //   return ReactHtmlParser(defaultOption);
    // }
    const section = {
      // html,
      data,
    };

    return (
      <CustomRevvEditor
        section={section}
        mode={OptionView.mode}
        isComponentActive={this.props.isActive}
        handleBlur={this._updateOption}
        isDocCustomTextEditor={false}
        isCustomTableTextEditor={false}
        isSeparateToolbar={false}
        readOnly={false}
      />
    );
  };

  _updateOption = content => {
    const { option, updateOption, toggleActiveOption } = this.props;
    const { data } = content;
    updateOption(option.id, data);
    toggleActiveOption(null);
  };

  render() {
    const {
      type,
      count,
      isDefault,
      option: { id },
      deleteOption,
      toggleActiveOption,
      toggleDefaultOption,
    } = this.props;
    return (
      <div
        className="clause-options-view"
        data-test="optionview-clause-options-view">
        {type !== CLAUSES_OPTIONS.FREE_TEXT && (
          <div
            className="clause-options-view-header"
            dat-test="optionview-clause-options-view-header">
            <div
              className="clause-options-view-count"
              data-test="optionview-clause-options-view-count">
              {`Clause Option ${count}`}
            </div>

            <div
              className="clause-options-view-default"
              data-test="optionview-clause-options-view-default">
              {toggleDefaultOption && (
                <div data-test="optionview-clause-options-checkbox-section">
                  <Label
                    htmlFor="clause-options-view-checkbox"
                    data-test="optionview-clause-options-view-checkbox-label">
                    <Input
                      className="clause-options-view-checkbox"
                      data-test="optionview-clause-options-view-checkbox-input"
                      type="checkbox"
                      checked={Boolean(isDefault)}
                      onChange={() => toggleDefaultOption(id)}
                    />
                    <span data-test="optionview-clause-options-view-checkbox-description">
                      This is default value
                    </span>
                  </Label>
                </div>
              )}
              {deleteOption && (
                <div
                  className="clause-options-view-delete"
                  data-test="optionview-clause-options-view-delete">
                  <span
                    className="btn-icon"
                    data-test="optionview-clause-options-view-delete-icon"
                    onClick={() => deleteOption(id)}
                    onKeyDown={() => {}}
                    role="button"
                    tabIndex={0}>
                    <Tooltip
                      placement="top"
                      overlay="Delete this option"
                      data-test="optionview-clause-options-view-delete-tooltip">
                      <FontAwesomeIcon icon={["far", "trash-alt"]} />
                    </Tooltip>
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        <div
          className="clause-options-view-value"
          data-test="optionview-clause-options-view-value"
          onClick={() => toggleActiveOption(id)}
          onKeyDown={() => toggleActiveOption(id)}
          role="button"
          tabIndex={0}>
          <div
            className="clause-options-view-value-box"
            data-test="optionview-clause-options-view-value-box">
            {this._getOptionView()}
          </div>
        </div>
      </div>
    );
  }
}

export default OptionView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/ClauseOptions/OptionView.js